import _util from '../../utils/';


const externalCourseService = {
	selectExternalCourse(gets, resolve, reject) {
		_util.request({
			url: '/api/HRExternalTraining/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	selectExternalCourseDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HRExternalTraining/Details',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	createExternalCourse(posts, resolve, reject) {
		_util.request({
			url: '/api/HRExternalTraining/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})
	},
	updateExternalCourse(puts, resolve, reject) {
		_util.request({
			url: '/api/HRExternalTraining/Put',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})		
	},
	deleteExternalCourse(deletes, resolve, reject) {
		_util.request({
			url: '/api/HRExternalTraining/Delete',
			method: 'delete',
			data: deletes,
			success: resolve,
			error: reject
		})		
	},
	exportExternalCourse(gets, resolve, reject) {
		_util.request({
			url: '/api/HRExternalTraining/Export',
			params: gets,
			success: resolve,
			error: reject
		})		
	},
	joinExternalCourse(puts, resolve, reject) {
		_util.request({
			url: '/api/HRInternalTraining/JoinTheTrainingCourse',
			method: "put",
			data: puts,
			success: resolve,
			error: reject
		})
	},
	uploadCourseAttachments(posts, resolve, reject) {
		_util.request({
			url: '/api/HRTrainingAttachmants/Upload',
			method: "post",
			data: posts,
			success: resolve,
			error: reject
		})
	},
	notifyAll(gets, resolve, reject) {
		_util.request({
			url: '/api/HRTrainingCourseNotification/NotificationAll',
			method: "post",
			data: gets,
			success: resolve,
			error: reject
		})
	},
	notifySingle(gets, resolve, reject) {
		_util.request({
			url: '/api/HRTrainingCourseNotification/Notification',
			method: "post",
			data: gets,
			success: resolve,
			error: reject
		})
	}
};


export default externalCourseService;


// WEBPACK FOOTER //
// ./src/services/Training/external-course-service.js